export const LECTURE_CONTENT_TYPES = {
  preLecture: 'pre_lecture',
  postLecture: 'post_lecture',
  literatureResource: 'literature_resource',
};
